import * as React from "react";
import { Card, Divider } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { v4 as uuidv4 } from "uuid";
import { CpArrayObject } from "../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemIpSetLocation } from "./CpArrayItemIpSetLocation";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { getDefaultKindSelectState } from "../../../components/antd/kindselect/KindSelect";
import { IpSetSpecTarget } from "./target";

interface Props {
  /** If provided, locks the target based on the link type (gvc or workload) */
  lockedLink?: string;
}
export const Editable: React.FC<Props> = ({ lockedLink }) => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Spec
            <CpErrorWarningArrayIcon names={[`gvc`, "workload", "locations"]} />
          </CardTitle>
          <CardContent>
            <IpSetSpecTarget lockedLink={lockedLink} />
            <Divider orientation="left" orientationMargin={0}>
              Locations
            </Divider>
            <div style={{ maxWidth: 600 }}>
              <CpArrayObject
                labels={[
                  { label: "Location", span: 3 },
                  { label: "Retention Policy", span: 1 },
                ]}
                name="locations"
                factoryFn={() => ({ id: uuidv4(), location: getDefaultKindSelectState(), retentionPolicy: "keep" })}
              >
                <CpArrayItemIpSetLocation />
              </CpArrayObject>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
